import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import CryptoSelector from './components/CryptoSelector';
import OrderForm from './components/OrderForm';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import FlashFeatures from './components/FlashFeatures';
import Roadmap from './components/Roadmap';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';

function App() {
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showOutOfStock, setShowOutOfStock] = useState(false);

  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
    setShowOrderForm(true);
    setShowOutOfStock(false);
  };

  const handleBackToSelection = () => {
    setShowOrderForm(false);
    setShowOutOfStock(false);
    setSelectedCrypto(null);
  };

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero onGetStarted={() => document.getElementById('crypto-selector').scrollIntoView({ behavior: 'smooth' })} />
              <div id="crypto-selector">
                {!showOrderForm && !showOutOfStock ? (
                  <CryptoSelector onSelectCrypto={handleCryptoSelect} />
                ) : showOutOfStock ? (
                  <div className="out-of-stock-container">
                    <div className="out-of-stock-card">
                      <div className="out-of-stock-icon">
                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2"/>
                          <path d="M12 8v4M12 16h.01" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </div>
                      <h2>Currently Out of Stock</h2>
                      <div className="crypto-info">
                        <img src={selectedCrypto?.icon} alt={selectedCrypto?.name} />
                        <h3>{selectedCrypto?.name}</h3>
                      </div>
                      <p className="out-of-stock-message">
                        We're sorry, but <strong>{selectedCrypto?.name}</strong> is currently out of stock. 
                        Please check back later or choose another network.
                      </p>
                      <div className="stock-status">
                        <div className="status-badge out">
                          <span className="status-dot"></span>
                          Out of Stock
                        </div>
                      </div>
                      <button className="back-to-selection-btn" onClick={handleBackToSelection}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        Choose Another Network
                      </button>
                    </div>
                  </div>
                ) : (
                  <OrderForm 
                    selectedCrypto={selectedCrypto} 
                    onBack={handleBackToSelection}
                  />
                )}
              </div>
              <Features />
              <HowItWorks />
              <FlashFeatures />
              <Roadmap />
              <SEOContent />
            </>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
